// components
import { Navbar, Footer } from "@/components";
import { ProfileSection } from "@/components/profile-form";

export default function EditProfilePage() {
  return (
    <>
      <Navbar />
      <ProfileSection />
      <Footer />
    </>
  );
}

